<template>
    <div class="page box has-text-dark" id="read">

        <div v-if="curr_tab" class="content pb-4">

            <b-button class="is-pulled-right" tag="router-link"
                to="/"
                type="is-danger" outlined icon-left="home">
                Retour
            </b-button>

            <div class="tabs pt-5">
            <ul>
                <li v-for="tab in curr_tab" v-bind:key="tab.route_name" v-bind:class="[tab.route_name == curr_route ? 'is-active' : '']">
                    <router-link :to="tab.route_url">{{ tab.route_title }}</router-link>
                </li>
            </ul>
        </div>
        </div>

        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="notification is-light">
            <NotFound />
        </div>
        <div v-if="page" class="content px-5 py-2">
            <b-button v-if="!curr_tab" class="is-pulled-right" tag="router-link"
                to="/"
                type="is-danger" outlined icon-left="home">
                Retour
            </b-button>
            <h1 class="title is-4 pb-3 py-2">{{page.title | capitalize}}</h1>
            <span :data-pagename="page.title" v-html="page.content"></span>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
import NotFound from './NotFound.vue'

export default {
    data: function() {
        return {
            loading: true,
            page: null,
            error: null,
            curr_route: null,
            curr_tab: null,
            maintitle: 'Page',
            pagetabs: {
                recherche : [{
                    route_url : '/page/recherche',
                    route_name : 'recherche',
                    route_title : 'Recherche'
                    },
                    {
                    route_url : '/page/publications',
                    route_name : 'publications',
                    route_title : 'Publications'
                }],
                enseignement : [{
                    route_url : '/page/enseignement',
                    route_name : 'enseignement',
                    route_title : 'Diplôme Universitaire'
                    },
                    {
                    route_url : '/page/option-ppa',
                    route_name : 'option-ppa',
                    route_title : 'Option PPA'
                    },
                    {
                    route_url : '/page/videos-pedagogiques',
                    route_name : 'videos-pedagogiques',
                    route_title : 'Vidéos'
                    },

                    ]
            }
        }
    },
    name: 'Page',
    components: {
        NotFound
    },
    props: {
        pagetab: String
    },
    created() {
        this.fetchData()
        this.curr_route = this.$route.params.id
        this.curr_tab = this.pagetabs[this.pagetab] ?? null
    },
    updated() {
        this.curr_route = this.$route.params.id
        this.maintitle = this.page ? this.page.title : this.maintitle;

        // specific to Equipe page
        var images = this.$el.querySelectorAll("[data-pagename='Equipe'] img")
        if(images){
            images.forEach((img) => {
                img.width = "150"
                img.style.borderRadius = "50%"
            });
        }
        var tab_trombi = this.$el.querySelectorAll("[data-pagename='Equipe'] table td")
        tab_trombi.forEach((td) => {
                td.style.borderWidth = "0px"
            });
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.error = this.page = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_pages + '&limit=1&populate=1&filter[slug]=' + encodeURIComponent('page/' + vm.$route.params.id)
            axios({
                    method: 'get',
                    url: fetchurl
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.page = response.data.entries[0]
                        vm.error = null
                    } else {
                        vm.page = null
                        vm.error = 'page introuvable'
                        vm.$router.push({ name: '404' })

                    }
                })
                .catch(function() {
                    vm.error = 'page introuvable'
                    vm.$router.push({ name: '404' })
                })

        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

div {
  word-wrap: break-word;
}

.page {
    min-height: 300px;
    margin-bottom: 100px;
    margin-top: 100px;
}

.box {
    border-radius: 0px;
    border-left: 12px solid #ff3860;
    box-shadow: 1px 1px 12px #555;
}

li.is-activew {
    font-weight: bold;
}

li a {
    font-size: 14pt;

}

li.is-active a {
    border-bottom-color: #ff3860 !important;
    color: white !important;
    background: #ff3860;
}


@media only screen and (max-width: 600px) {
  .page {
    margin-bottom: 50px;
    margin-top: 50px;
  }
}

</style>